import { render } from "./text-pillars.vue?vue&type=template&id=0cc45642&scoped=true"
const script = {}

import "./text-pillars.vue?vue&type=style&index=0&id=0cc45642&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc45642"],['__file',"src/views/other/cssfx/components/text-pillars.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cc45642"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cc45642', __exports__)) {
    console.log('reload')
    api.reload('0cc45642', __exports__)
  }
  
  module.hot.accept("./text-pillars.vue?vue&type=template&id=0cc45642&scoped=true", () => {
    console.log('re-render')
    api.rerender('0cc45642', render)
  })

}


export default __exports__